import React, { useState, useEffect } from "react";
import ReactApexChart from 'react-apexcharts';

const BarChart = (props) => {
    const { selectedYear } = props;

    const [barChartValues, setBarChartValues] = useState({
        data: [0, 0],
        categories: ['Online', 'Physical']
    });
    const [trainingInformation, setTrainingInformation] = useState({});
    // Initialize counters

    const dateRangesEx = () => {
        // Iterate through the nested objects
        let physicalCount =0;
        let onlineCount =0;
        for (const year in trainingInformation) {
            for (const dateRange in trainingInformation[year]) {
                const trainingMode = trainingInformation[year][dateRange].trainingMode;
                // Check the trainingMode value and update counters
                if (trainingMode === "Physical") {
                    physicalCount += 1;
                } else if (trainingMode === "Online") {
                    onlineCount += 1;
                }
            }
        }
        setBarChartValues(prevValues => ({
            ...prevValues,
            data:[onlineCount, physicalCount]
        }));
    }

    useEffect(() => {
        if (selectedYear) {
            const plannedEvents = localStorage.getItem("plannedEvent");
            setTrainingInformation(JSON.parse(plannedEvents));
        }
    }, [selectedYear]);

    useEffect(() => {
        if (Object.entries(trainingInformation).length > 0) {
            dateRangesEx()
        }
    }, [trainingInformation, selectedYear])

    console.log(barChartValues);

    const trainingOptions = {
        series: [{
            data: barChartValues.data,
        },
        ],
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                type: 'horizontal',
                shadeIntensity: 0.5,
                gradientToColors: ['#2D9CDB', 'rgba(45, 156, 219, 0.2)'],
                inverseColors: true,
                opacityFrom: 0.5,
                opacityTo: 1,
                stops: [0, 100],
            },
        },
        chart: {
            height: 150,
            type: 'bar',
            toolbar: {
                show: false,
            },
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            bar: {
                borderRadius: 10,
                columnWidth: '45%',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            style: {
                fontSize: '12px',
                colors: ["#fff"]
            }
        },

        xaxis: {
            categories: barChartValues.categories,
            position: 'bottom',
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: '#fff',
                },
            },
            tooltip: {
                enabled: false,
            },
            crosshairs: {
                show: false,
            },
        },
        yaxis: {
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            },
            labels: {
                show: false,
            }
        },
        title: {
            text: 'Training Mode',
            floating: true,
            offsetY: 330,
            align: 'left',
            style: {
                color: '#fff'
            }
        }
    }

    return (
        <ReactApexChart options={trainingOptions} series={trainingOptions.series} type="bar" height={200} />
    )
};

export default BarChart;